<template>
  <div>
    <mdb-modal size="lg" :show="modalState" @close="close">
        <mdb-modal-header>
            <mdb-modal-title><h3>Wichtiges</h3></mdb-modal-title>
        </mdb-modal-header>
        <mdb-modal-body>
          <div class="d-flex justify-content-center">
            <mdb-spinner big v-if="loading"/>
          </div>
          <mdb-tbl
            striped
            v-if="detailsList.length > 0">
            <mdb-tbl-body>
              <tr
                v-for="(detail, index) in detailsList"
                :key="index"
              >
                <td v-html="detail.Ueberschrift"></td>
                <td><span v-html="detail.Text "></span></td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
          <list-group-item
            v-else
            class="mt-2"
            :title="'Keine Einträge gefunden'"
          />
        </mdb-modal-body>
        <mdb-modal-footer>
            <mdb-btn color="primary" size="sm" @click.native="close">OK</mdb-btn>
        </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
  import utils from '@/mixins/Utils'
  import {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn,
    mdbTbl,
    mdbTblBody,
    mdbSpinner
  } from 'mdbvue'
  const ListGroupItem = () => import('@/components/accordion/ListGroupItem')

  export default {
    name: 'PatientDetailModal',
     mixins: [utils()],

    components: {
      mdbModal,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalBody,
      mdbModalFooter,
      mdbBtn,
      mdbTbl,
      mdbTblBody,
      mdbSpinner,
      ListGroupItem
    },

    props: {
      modalState: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        detailsList: [],
        loading: false
      }
    },

    created() {
      this.loadDetails()
    },

    methods: {
      close () {
        this.$emit('close')
      },

      loadDetails () {
        const ID = this.roomID
        this.loading =true
        this.$http.get(`Nachricht/${ID}`)
          .then(res => {
            this.detailsList = res.data.data
          })
          .finally(() => {
            this.loading = false
          })
      }
    }
  }
</script>
